export type SortValue = 'price.asc' | 'price.desc' | 'dispatch.asc' | 'dispatch.desc';

export type AreaFilters = {
    brands: string[];
    categories: string[];
    priceMin: null | number;
    priceMax: null | number;
    sort: null | SortValue;
    page: null | number;
    search: null | string;
};

export const areaFiltersEmpty = {
    brands: [],
    categories: [],
    priceMin: null,
    priceMax: null,
    sort: null,
    page: 1,
    search: null,
} as AreaFilters;

export const areaFiltersDefault = {
    brands: [],
    categories: [],
    priceMin: null,
    priceMax: null,
    sort: 'price.asc',
    page: 1,
    search: null
} as AreaFilters;

export const mergeDefaults = (values: AreaFilters) => {
    const cloned = structuredClone(values);
    const defaults = structuredClone(areaFiltersDefault);

    cloned.brands = cloned.brands ?? defaults.brands;
    cloned.categories = cloned.categories ?? defaults.categories;
    cloned.priceMin = cloned.priceMin ?? defaults.priceMin;
    cloned.priceMax = cloned.priceMax ?? defaults.priceMax;
    cloned.sort = cloned.sort ?? defaults.sort;
    cloned.page = cloned.page ?? defaults.page;
    cloned.search = cloned.search ?? defaults.search;

    return cloned;
};

const hashes = new WeakMap<AreaFilters, string>();
const groupHashes = new WeakMap<AreaFilters, string>();
const fillHashes = new WeakMap<AreaFilters, string>();

export const getHash = (filters: AreaFilters, recalc = false) => {
    if (recalc || !hashes.has(filters)) {
        hashes.set(filters, createHash(filters));
    }

    return hashes.get(filters)!;
};

export const getGroupHash = (filters: AreaFilters, recalc = false) => {
    if (recalc || !groupHashes.has(filters)) {
        groupHashes.set(filters, createGroupHash(filters));
    }

    return groupHashes.get(filters)!;
};
export const getFillHash = (filters: AreaFilters, recalc = false) => {
    if (recalc || !fillHashes.has(filters)) {
        fillHashes.set(filters, createFillHash(filters));
    }

    return fillHashes.get(filters)!;
};
export const createHash = (filters: AreaFilters) => JSON.stringify(filters);
export const createGroupHash = (filters: AreaFilters) => JSON.stringify({ ...filters, page: 0 });
export const createFillHash = (filters: AreaFilters) => JSON.stringify({ ...filters, page: 0, sort: null });
export const isFiltersEmpty = (filters: AreaFilters) => {
    const hash = getFillHash(filters, true);
    return hash === getFillHash(areaFiltersEmpty);
};